import { Injectable } from '@angular/core';
import { User } from '@model/user/user';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LocalSettingsKey } from '@shared/types/local-settings';
import { UtilService } from '@service/utils/util.service';
import { DesktopClientService } from '../login/desktop-client.service';
import packageJson from '../../../../../package.json';

@Injectable({
  providedIn: 'root'
})
export class HttpHeadersService {
  public version: string = packageJson.version;

  constructor(
    private deviceDetectorService: DeviceDetectorService,
    private desktopClientService: DesktopClientService
  ) { }

  generateDeviceId(): string {
    return this.getClientLoginParam('deviceId') || localStorage.getItem(LocalSettingsKey.DEVICE_ID) || this.setUUID();
  }

  setUUID(): string {
    const uuid = UtilService.generateUUID();
    localStorage.setItem(LocalSettingsKey.DEVICE_ID, uuid);
    return uuid;
  }

  generateDeviceName(): string {
    return this.getClientLoginParam('deviceName') || (this.deviceDetectorService.os + ' - ' +
      this.deviceDetectorService.browser + ' ' + this.deviceDetectorService.browser_version);
  }

  generateDeviceOs(): string {
    return this.getClientLoginParam('deviceOs') || 'WEB';
  }

  generateDeviceLanguage(): string {
    return this.getClientLoginParam('deviceLanguage') || navigator.language.replace('-', '_');
  }

  generateAppVersion(): string {
    return this.getClientLoginParam('appVersion') || this.version;
  }

  private getClientLoginParam(field: string): string {
    const clientLoginQueryParams = this.desktopClientService.getExtInfo();
    if (clientLoginQueryParams) {
      return clientLoginQueryParams[field];
    }
    return null;
  }
}

